import { ApiUrl } from '@common/enums';
import { EndSplashProduct } from '@common/models';
import { easyEstimatorApi } from '@ee-api/easyEstimatorService';
import { CommonProductQueryParams } from '@ee-api/queryParams';

const endSplashService = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchEndSplash: builder.query<EndSplashProduct[], CommonProductQueryParams>({
            query: ({ params }) => ({
                url: ApiUrl.LAMINATE_SPLASHES,
                method: 'GET',
                params,
            }),
        }),
    }),
});

export const { useFetchEndSplashQuery, useLazyFetchEndSplashQuery } = endSplashService;
